import { Component } from 'react';
import PropTypes from 'prop-types';

import PNotify from 'pnotify';
import 'pnotify/dist/pnotify.history';
import 'pnotify/dist/pnotify.buttons';
import 'pnotify/dist/pnotify.callbacks';
import 'pnotify/dist/pnotify.css';
import 'pnotify/dist/pnotify.buttons.css';

PNotify.prototype.options.styling = 'fontawesome';
PNotify.prototype.options.delay = 2000;
PNotify.prototype.options.mouse_reset = true;
PNotify.prototype.options.destroy = true;
PNotify.prototype.options.history.maxonscreen = 2;
PNotify.prototype.options.buttons.closer_hover = false;
PNotify.prototype.options.buttons.sticker = false;
PNotify.prototype.options.buttons.classes = { closer: 'fa fa-times-circle' };

class Growl extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    text: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['danger', 'info', 'success', 'warning']),
  };

  shouldComponentUpdate = (nextProps) => {
    return nextProps.id !== this.props.id;
  };

  componentWillMount = () => {
    const options = {};

    const types = {
      warning: 'notice',
      info: 'info',
      success: 'success',
      danger: 'error',
    };

    const iconTypes = {
      warning: 'fa fa-exclamation',
      info: 'fa fa-info',
      success: 'fa fa-check',
      danger: 'fa fa-times',
    };

    options.title = this.props.title ? this.props.title : this.props.text;
    options.type = types[this.props.type];
    options.icon = iconTypes[this.props.type];

    options.after_open = () => {
      this.props.handleRemove(this.props.id);
    };

    if (this.props.title && this.props.text) options.text = this.props.text;

    const notice = new PNotify(options);

    notice.elem[0].addEventListener('click', () => {
      notice.remove();
    });
  };

  render = () => {
    return null;
  };
}

export default Growl;



// WEBPACK FOOTER //
// src/modules/messages/components/GrowlMessage.js